var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KButton',{attrs:{"text":"Icon After","iconAfter":"video"}})
}
var staticRenderFns = []

export { render, staticRenderFns }